import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import classNames from "classnames/bind";

import UIIcon, { BACKGROUNDABLE_ICONS, NON_BACKGROUNDABLE_ICONS } from "../UIIcon";
import styles from "./IconButton.module.scss";

const cx = classNames.bind(styles);

type IconButtonProps = DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
> & {
    icon: keyof typeof NON_BACKGROUNDABLE_ICONS | keyof typeof BACKGROUNDABLE_ICONS;
    onClick: () => void;
    className?: string;
};

const IconButton: React.FC<IconButtonProps> = (props) => {
    const { onClick, icon, className, type = "button", ...rest } = props;

    return (
        <button onClick={onClick} type={type} className={cx("button", className)} {...rest}>
            <UIIcon icon={icon} />
        </button>
    );
};

IconButton.displayName = "IconButton";

export default IconButton;
